var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConveyerBelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 51,
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9276 6.78759C30.8379 3.69785 26.7282 2 22.3606 2C17.987 2 13.8833 3.69785 10.7936 6.78759C7.70385 9.87732 6 13.987 6 18.3546C6 27.1918 14.3573 34.5472 18.8509 38.4948C19.4748 39.0468 20.0088 39.5208 20.4408 39.9167C20.9807 40.4207 21.6706 40.6727 22.3606 40.6727C23.0505 40.6727 23.7405 40.4207 24.2744 39.9167C24.7064 39.5208 25.2463 39.0468 25.8703 38.4948C30.3579 34.5472 38.7152 27.1918 38.7152 18.3546C38.7152 13.987 37.0173 9.87732 33.9276 6.78759Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1527 13H18.3284V14.9609H16.1527V13Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4971 13H27.6728V14.9609H25.4971V13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4281 13H28.3786V15.6668H24.7943V13H22.7448V17.075H24.7943C24.9887 17.075 25.1455 17.2319 25.1455 17.4263C25.1455 17.6206 24.9887 17.7775 24.7943 17.7775H22.7448V18.2855H26.213C26.4073 18.2855 26.5642 18.4424 26.5642 18.6367C26.5642 18.8311 26.4073 18.9879 26.213 18.9879L22.7448 18.9883V19.926H30.4279L30.4281 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0807 13H19.0312V15.6668H15.4471V13H13.3975V17.075H15.4469C15.6413 17.075 15.7981 17.2319 15.7981 17.4263C15.7981 17.6206 15.6413 17.7775 15.4469 17.7775L13.3975 17.7776V18.2857H16.8657C17.0601 18.2857 17.2169 18.4425 17.2169 18.6369C17.2169 18.8313 17.0601 18.9881 16.8657 18.9881L13.3975 18.9883V19.926H21.0805L21.0807 13Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6427 21.3346H13.1826C11.9755 21.3346 11 22.3133 11 23.5172C11 24.7244 11.9788 25.6998 13.1826 25.6998H30.6431C31.8503 25.6998 32.8258 24.7211 32.8258 23.5172C32.8256 22.3133 31.8469 21.3346 30.643 21.3346H30.6427ZM13.9567 24.5129C13.4077 24.5129 12.9609 24.0662 12.9609 23.517C12.9609 22.968 13.4075 22.5212 13.9567 22.5212C14.5057 22.5212 14.9525 22.9679 14.9525 23.517C14.9491 24.0661 14.5059 24.5129 13.9567 24.5129ZM17.933 24.5129C17.384 24.5129 16.9372 24.0662 16.9372 23.517C16.9372 22.968 17.3839 22.5212 17.933 22.5212C18.4821 22.5212 18.9289 22.9679 18.9289 23.517C18.9289 24.0661 18.4821 24.5129 17.933 24.5129ZM21.9128 24.5129C21.3638 24.5129 20.917 24.0662 20.917 23.517C20.917 22.968 21.3637 22.5212 21.9128 22.5212C22.4619 22.5212 22.9087 22.9679 22.9087 23.517C22.9087 24.0661 22.4619 24.5129 21.9128 24.5129ZM25.8926 24.5129C25.3436 24.5129 24.8968 24.0662 24.8968 23.517C24.8968 22.968 25.3434 22.5212 25.8926 22.5212C26.4416 22.5212 26.8885 22.9679 26.8885 23.517C26.8883 24.0661 26.4416 24.5129 25.8926 24.5129ZM29.869 24.5129C29.3199 24.5129 28.8731 24.0662 28.8731 23.517C28.8731 22.968 29.3198 22.5212 29.869 22.5212C30.418 22.5212 30.8648 22.9679 30.8648 23.517C30.8646 24.0661 30.4213 24.5129 29.869 24.5129Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_117",
    x: 0.5,
    y: 0.5,
    width: 43.7152,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_117"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_117",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConveyerBelt);
export default __webpack_public_path__ + "static/media/conveyer-belt.6782e55b8e0928b721cb5dc1d870af1a.svg";
export { ForwardRef as ReactComponent };